<template lang="pug">
div.upper-subpanel--inside
  ConfirmFlow(v-if="stage === 'confirm'" v-on:confirmationFinish="getConfirmData" :actionType="actionType")

</template>

<script>
import { faArrowDown, faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import ConfirmFlow from './ConfirmFlow';

export default {
  name: 'LockBoxMultiFlow',
  props: ['actionType'],
  data() {
    return {
      stage: '',
    };
  },
  components: {
    ConfirmFlow,
  },
  created() {
    this.$store.commit('SET_CURRENT_DEVICE_FROM_SELECTED', this.selectedDevicesID[0]);
    this.setFakeMedication();
  },
  mounted() {
    this.stage = 'confirm';
  },
  methods: {
    getConfirmData() {
      this.stage = 'finish';
      if (this.nextDevice !== null) {
        this.$store.commit('SET_CURRENT_DEVICE_FROM_SELECTED', this.nextDevice.id);
        setTimeout(() => {
          this.stage = 'confirm';
        }, 100);
      } else {
        this.$emit('setAllConfirmData');
      }
    },
    setFakeMedication() {
      this.instance.get('/api/medication/', {
        params: {
          code: 'Lock_Med',
        },
      })
      .then((res) => {
        this.$store.dispatch('setDrug', res.data.results[0].id);
      });
    },
  },
  computed: {
    nextDevice() {
      return this.$store.state.device.nextDevice;
    },
    selectedDevicesID() {
      return this.$store.state.device.selectedDevicesID;
    },
    instance() {
      return this.$store.getters.instance;
    },
    arrowDownIcon() {
      return faArrowDown;
    },
    boxOpenIcon() {
      return faBoxOpen;
    },
  },
};
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// MultiFlow.vue?019b080d